
const UPLOAD_LIMITDB_SUCCESS = 'UPLOAD_LIMITDB_SUCCESS'
const UPLOAD_LIMITDB_FAIL = 'UPLOAD_LIMITDB_FAIL'
const UPLOAD_MANUFACTURERDB_SUCCESS = 'UPLOAD_MANUFACTURERDB_SUCCESS'
const UPLOAD_MANUFACTURERDB_FAIL = 'UPLOAD_MANUFACTURERDB_FAIL'
const UPLOAD_LOG_GET_SUCCESS = 'UPLOAD_LOG_GET_SUCCESS'
const UPLOAD_LOG_GET_FAIL = 'UPLOAD_LOG_GET_FAIL'
const UPLOAD_DEVICE_SOFTWARE_SUCCESS = 'UPLOAD_DEVICE_SOFTWARE_SUCCESS'
const UPLOAD_DEVICE_SOFTWARE_FAIL = 'UPLOAD_DEVICE_SOFTWARE_FAIL'
const UPLOAD_ADAPTER_POLICY_SUCCESS = 'UPLOAD_ADAPTER_POLICY_SUCCESS'
const UPLOAD_ADAPTER_POLICY_FAIL = 'UPLOAD_ADAPTER_POLICY_FAIL'

export const defaultSettingState = {
  log: null
}

export default (state = defaultSettingState, action) => {
  switch (action.type) {
    case UPLOAD_LIMITDB_SUCCESS: {
      return state
    }
    case UPLOAD_LIMITDB_FAIL: {
      return state
    }
    case UPLOAD_MANUFACTURERDB_SUCCESS: {
      return state
    }
    case UPLOAD_MANUFACTURERDB_FAIL: {
      return state
    }
    case UPLOAD_DEVICE_SOFTWARE_SUCCESS:
    case UPLOAD_DEVICE_SOFTWARE_FAIL: {
      return state
    }
    case UPLOAD_ADAPTER_POLICY_SUCCESS:
    case UPLOAD_ADAPTER_POLICY_FAIL: {
      return state
    }
    case UPLOAD_LOG_GET_SUCCESS: {
      return {
        ...state,
        log: action.payload.data
      }
    }
    case UPLOAD_LOG_GET_FAIL: {
      return state
    }
    default:
      return state
  }
}
